define(
    'viewmodels/secured/explorer/details/noDocument',[
        "viewmodels/ViewModel",
        "i19n!i19n/strings"
    ],
    function (ViewModel, i19n) {

        var vm = new ViewModel(
        {
            i19n: i19n
        });

        return vm;
    });
